import React, { useEffect, useState } from 'react';
import api from '../api';
import './PageTable.css';

function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [form, setForm] = useState({
    title: '', description: '', location: '', city: '',
    event_date: '', poster_url: '', status: 'upcoming',
  });

  const fetchEvents = async () => {
    setLoading(true);
    try {
      const res = await api.get('/admin-events/all');
      setEvents(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('photo', file);
      const res = await api.post('/admin-upload/image', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setForm((f) => ({ ...f, poster_url: res.data.url }));
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal upload gambar');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const openCreate = () => {
    setForm({ title: '', description: '', location: '', city: '', event_date: '', poster_url: '', status: 'upcoming' });
    setModal({});
  };

  const openEdit = (item) => {
    setForm({
      title: item.title,
      description: item.description || '',
      location: item.location || '',
      city: item.city || '',
      event_date: item.event_date ? item.event_date.slice(0, 16) : '',
      poster_url: item.poster_url || '',
      status: item.status,
    });
    setModal(item);
  };

  const submitForm = async (e) => {
    e.preventDefault();
    try {
      if (modal.id) {
        await api.put(`/admin-events/${modal.id}`, form);
      } else {
        await api.post('/admin-events', form);
      }
      setModal(null);
      await fetchEvents();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menyimpan event');
    }
  };

  const deleteEvent = async (id) => {
    if (!window.confirm('Hapus event ini?')) return;
    try {
      await api.delete(`/admin-events/${id}`);
      await fetchEvents();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menghapus event');
    }
  };

  return (
    <div>
      <div className="page-header-row">
        <h1 className="page-title" style={{ marginBottom: 0 }}>Event</h1>
        <button className="btn-primary" onClick={openCreate}>+ Tambah Event</button>
      </div>
      {loading ? (
        <p>Memuat...</p>
      ) : (
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Artwork</th>
                <th>Judul</th>
                <th>Kota</th>
                <th>Tanggal</th>
                <th>Status</th>
                <th>Aksi</th>
              </tr>
            </thead>
            <tbody>
              {events.map((ev) => (
                <tr key={ev.id}>
                  <td>
                    <div style={{ width: 44, height: 56, borderRadius: 4, overflow: 'hidden', background: '#303034' }}>
                      {ev.poster_url && (
                        <img src={ev.poster_url} alt={ev.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
                      )}
                    </div>
                  </td>
                  <td>{ev.title}</td>
                  <td>{ev.city || '-'}</td>
                  <td>{new Date(ev.event_date).toLocaleDateString('id-ID')}</td>
                  <td><span className={`status-badge status-${ev.status === 'upcoming' ? 'approved' : 'pending'}`}>{ev.status}</span></td>
                  <td>
                    <div className="action-buttons">
                      <button className="btn-edit" onClick={() => openEdit(ev)}>Edit</button>
                      <button className="btn-delete" onClick={() => deleteEvent(ev.id)}>Hapus</button>
                    </div>
                  </td>
                </tr>
              ))}
              {events.length === 0 && (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', color: '#888' }}>
                    Belum ada event
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <form className="modal-box" onClick={(e) => e.stopPropagation()} onSubmit={submitForm}>
            <h2>{modal.id ? 'Edit Event' : 'Tambah Event Baru'}</h2>
            <input
              type="text"
              placeholder="Judul event"
              value={form.title}
              onChange={(e) => setForm({ ...form, title: e.target.value })}
              required
            />
            <textarea
              placeholder="Deskripsi"
              rows={3}
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
            />
            <input
              type="text"
              placeholder="Lokasi (nama venue)"
              value={form.location}
              onChange={(e) => setForm({ ...form, location: e.target.value })}
            />
            <input
              type="text"
              placeholder="Kota"
              value={form.city}
              onChange={(e) => setForm({ ...form, city: e.target.value })}
            />
            <label style={{ display: 'block', fontSize: 12, color: '#888', marginTop: 8 }}>Tanggal & Waktu Event</label>
            <input
              type="datetime-local"
              value={form.event_date}
              onChange={(e) => setForm({ ...form, event_date: e.target.value })}
              required
            />
            <label style={{ display: 'block', fontSize: 12, color: '#888', marginTop: 8 }}>Artwork / Poster Event</label>
            <input
              type="url"
              placeholder="URL artwork event (atau upload dari perangkat di bawah)"
              value={form.poster_url}
              onChange={(e) => setForm({ ...form, poster_url: e.target.value })}
            />
            <div style={{ marginTop: 6 }}>
              <label style={{ display: 'inline-block', fontSize: 13, color: '#C9A66B', border: '1px solid #C9A66B', padding: '6px 14px', borderRadius: 6, cursor: 'pointer' }}>
                {uploading ? 'Mengupload...' : '📁 Upload dari Perangkat'}
                <input type="file" accept="image/jpeg,image/png,image/webp" onChange={handleFileUpload} disabled={uploading} style={{ display: 'none' }} />
              </label>
            </div>
            {form.poster_url && (
              <div style={{ width: 140, aspectRatio: '3/4', borderRadius: 8, overflow: 'hidden', marginTop: 8, background: '#303034' }}>
                <img src={form.poster_url} alt="Preview artwork" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
              </div>
            )}
            <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} style={{ marginTop: 8 }}>
              <option value="upcoming">Upcoming</option>
              <option value="sold_out">Sold Out</option>
              <option value="past">Selesai</option>
            </select>
            <div className="modal-actions">
              <button type="button" className="btn-secondary" onClick={() => setModal(null)}>Batal</button>
              <button type="submit" className="btn-primary">Simpan</button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}

export default Events;
